import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d661697"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "addRule" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "默认", -1))
const _hoisted_5 = { class: "item_main" }

import { searchRuleList } from '@/api/setting_rule';
import { onMounted, reactive } from 'vue'
import { LocalStorageService } from "@/components/ts/localStorage";
import { USER_INFO } from "@/store/mutation-types";
import roleForm from "./form.vue";
// let dataSource = reactive<any[]>([])

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const data = reactive<{
  dataSource: any[],
  loading: boolean,
  pagination: any,
  addVisible: boolean,
  type: string,
  id: number,
  ruleBrand:number
}>({
  dataSource: [],
  loading: false,
  pagination: {
    size: "large",
    current: 1,
    pageSize: 1000,
    total: 10,
    pageSizeOptions: ["10", "20", "30"], //可选的页面显示条数
    showTotal: (total: string) => {
      console.log(total);
      return " 共" + total + "条";
    }, //展示每页第几条至第几条和总数
    hideOnSinglePage: false, // 只有一页时是否隐藏分页器
    showSizeChanger: true, //是否可以改变pageSize
  },
  addVisible: false,
  type: 'add',
  id: 0,
  ruleBrand:0
})
onMounted(() => {
  init();
});

const init = () => {
  let option = {
    ruleOwner: LocalStorageService.get(USER_INFO).id,
    page: {
      currPage: data.pagination.current,
      pageSize: data.pagination.pageSize,
    },
    ruleBrand:data.ruleBrand
  };
  searchRuleList(option).then((res: any) => {
    if (res) {
      data.dataSource = res.data ? res.data : [];
      // data.pagination.total = res ? res.records : 0;

    }
  });
};
const addHandle = () => {
  console.log('添加规则');
  data.addVisible = true
  data.type = 'add'
  data.id = 0
}
const editHandle = (info: any) => {
  console.log('编辑', info);
  data.addVisible = true
  data.type = 'edit',
    data.id = info.id
}

const onCancel = () => {
  console.log('关闭规则');
  data.addVisible = false
  init()
}

const handleChange = () => {
  init();
}


return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      title: "临床规则",
      size: "small",
      bordered: false
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_select, {
          value: data.ruleBrand,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.ruleBrand) = $event)),
          style: {"width":"120px"},
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: 0 }, {
              default: _withCtx(() => [
                _createTextVNode("隐形")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("固定")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("拍照")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: [16, 16] }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "rulebody",
                  onClick: addHandle,
                  style: {"overflow":"hidden"}
                }, [
                  _createVNode(_component_a_card, {
                    hoverable: "",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_plus_outlined)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.dataSource, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                span: 6,
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "rulebody",
                    onClick: ($event: any) => (editHandle(item))
                  }, [
                    _createVNode(_component_a_card, {
                      title: item.ruleName,
                      hoverable: "",
                      size: "small"
                    }, _createSlots({
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(item.description), 1)
                      ]),
                      _: 2
                    }, [
                      (item.defaultStatus)
                        ? {
                            name: "extra",
                            fn: _withCtx(() => [
                              _hoisted_4
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["title"])
                  ], 8, _hoisted_3)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (data.addVisible)
      ? (_openBlock(), _createBlock(roleForm, {
          key: 0,
          isShow: data.addVisible,
          type: data.type,
          id: data.id,
          onOnCancel: onCancel
        }, null, 8, ["isShow", "type", "id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})